// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"f9e41546","163":"efb62f9d","261":"f7f9ed62","372":"f4159295","375":"fb0ba86c","477":"0d2a0263","656":"e3482f8f","811":"ed12119e","860":"673eb0d7"}[chunkId] + ".chunk.js";
};